/**
 * Animated mode behavior wrappers
 *
 * These behaviors are applied when rendering blocks in animated mode,
 * where position is driven by an animation timeline (0-1 progress).
 */

export { AnimatedPosition } from './AnimatedPosition'
